module.exports = __webpack_public_path__ + "img/4800.0fbf93a8.jpg";